import React from 'react';
import Reflux from 'reflux';
import _ from 'underscore';
import UserActions from 'flux/actions/UserActions';
import BaseMixin from 'flux/stores/BaseMixin';
import SignupActions from 'flux/actions/SignupActions';
import CuesheetTrackingActions from 'flux/actions/cuesheet/CuesheetTrackingActions';
import EventViewActions from 'flux/actions/EventViewActions';
import { isRemoteTeleprompter } from 'main/components/show/cuesheet/cuesheetViewHelper';

import socket from 'shared/lib/socket';

export default Reflux.createStore({
  mixins: [BaseMixin],

  listenables: [UserActions],

  init() {
    this.state = {};

    //for printable guest url's we don't need to load the user
    //and we dont need realtime sockets
    if (
      window.location.href.indexOf('guest') !== -1 ||
      (window.location.href.indexOf('printable') !== -1 &&
        !isRemoteTeleprompter())
    )
      return;

    this._socket = socket.get();

    UserActions.loadFromSession();

    this.listenTo(
      SignupActions.getByInviteToken.completed,
      'onGetByInviteTokenCompleted',
    );
    this.listenTo(
      CuesheetTrackingActions.clearTracking.completed,
      'onClearTrackingCompleted',
    );

    this.listenTo(EventViewActions.populate.completed, 'updateLastRole');
  },

  updateLastRole(teamId, eventId) {
    const { user } = this.state;
    if (!user) {
      this.userUpdateRoleCallback = () => this._updateLastRole(teamId, eventId);
    } else {
      this._updateLastRole(teamId, eventId);
    }
  },

  _updateLastRole(event) {
    const eventId = event._id;
    const teamId = event.team;
    const { user } = this.state;
    const { events, teams } = user;
    const changes = {};
    let latestEventRole = events.find(
      (eventRole) => eventRole.event === eventId,
    );
    if (latestEventRole && !_.isEqual(latestEventRole, user.lastEventRole)) {
      changes.lastEventRole = latestEventRole;
    }
    let latestTeamRole = teams.find((teamRole) => teamRole.team === teamId);
    if (latestTeamRole && !_.isEqual(latestTeamRole, user.lastTeamRole)) {
      changes.lastTeamRole = latestTeamRole;
    }

    if (Object.keys(changes).length > 0) {
      UserActions.update(user._id, changes);
    }
  },

  getInitialState() {
    return { user: null };
  },

  onSignupCompleted(user) {
    this.state.user = user;
    this.trigger(this.state);
  },

  onSignupWithTeamCompleted(userPlusTeam) {
    this.state.user = userPlusTeam.user;
    this.state.team = userPlusTeam.team;

    setTimeout(() => {
      this.trigger(this.state);
    }, 1000);
  },

  //TODO: refactor this..use reflection or something..
  onSignupWithTeamFailed(err) {
    this._triggerError(UserActions.signupWithTeam, err);
  },

  onSignupFailed(err) {
    this._triggerError(UserActions.signup, err);
  },

  onLoadFromSessionCompleted(user) {
    if (!user.hasSeenOnboarding) {
      UserActions.updateField(user._id, 'hasSeenOnboarding', true);
    }

    this.state.user = user;
    this.trigger(this.state);

    if (this.userUpdateRoleCallback) {
      this.userUpdateRoleCallback();
      delete this.userUpdateRoleCallback;
    }
  },

  // eslint-disable-next-line no-unused-vars
  onLoadFromSessionFailed(err) {
    //TODO..
  },

  // eslint-disable-next-line no-unused-vars
  _loginCompleted(user) {
    UserActions.loadFromSession();
  },

  onGetByInviteTokenCompleted(data) {
    this.state.signupSuccessUrl = data.url;
    this.trigger(this.state);
  },

  onClearTrackingCompleted(user) {
    this.state.user = user;
    this.trigger(this.state);
  },

  _triggerError(action, error) {
    //TODO: convert to use ErrorActions.report
    var message =
      typeof action === 'string' ? action : resolveErrorMessage(action, error);
    this.trigger({ errorMessage: message });
  },
});

/**
 * Makes it easy to i18n
 *
 * @param action
 * @param err
 * @returns {*}
 */
function resolveErrorMessage(action, err) {
  if (action === UserActions.signupWithTeam || action === UserActions.signup) {
    if (err.response.status === 409) {
      return <p>Signup attempt failed.</p>;
    } else {
      return 'Signup attempt failed.';
    }
  } else if (action === UserActions.login) {
    if (err.response.status === 401) {
      return <p>Invalid email and/or password.</p>;
    } else if (err.response.status === 429) {
      return (
        <p>
          You have reached the maximum failed login attempts allowed within 30
          minutes. You may <a href="/forgot">reset</a> your password to login,
          or wait until the lockout expires
        </p>
      );
    } else {
      return <p>Login attempt failed.</p>;
    }
  } else if (action === UserActions.checkFor2FactorAuthSecret) {
    return <p>Invalid email and/or password.</p>;
  } else {
    return <p>The operation failed.</p>;
  }
}
